
/**
 * 인쇄데이터 클래스
 * - qz용 출력 data 객체를 작성해줌
 * - 꼭 qz가 아니더라도 추상적으로는 출력되는 모든 인쇄데이터를 의미.
 * 
 * pdf출력, zpl출력 등...모든 출력케이스별로 정의 
 */
export class PrintData {
    constructor(options) {

        // 인쇄데이터 ID
        this.id = '';

        // 설명 (어떤종류의 출력인지 설명)
        this.desc = null;

        // qz 출력용 data 객체 생성해주는 함수 (프라미스 반환)
        this.makeQzDataPromise = null;

        if (options) {
            Object.assign(this, options);
        }

    }


    /**
     * 문자열로 변경
     * @returns {*}
     */
    toString() {
        return this.desc;
    }
}